import React, { useEffect, useState } from 'react';
import * as Icons from '@mui/icons-material';
import {Spinner} from "@material-tailwind/react";

interface CustomIconProps {
    iconName?: string;
    className?: string;
}

const CustomIcon: React.FC<CustomIconProps> = ({ iconName, className }) => {
    const [iconComponent, setIconComponent] = useState<React.ElementType | null>(null);

    useEffect(() => {
        if (iconName) {
            const Icon = (Icons as any)[iconName];
            if (Icon) {
                setIconComponent(Icon);
            }
        }
    }, [iconName]);

    if (!iconComponent) {
        return <Spinner className="h-4 w-4" color="blue" />;
    }

    const iconProps = {
        className: className
    }

    return <>{React.createElement(iconComponent, iconProps)}</>;
};

export default CustomIcon;
